import forwardMessage from './forwardMessage';
export var SAME_WINDOW_LAUNCH_TYPE = 'same_window';
var handleRequestFullWindowLaunch = function handleRequestFullWindowLaunch(event) {
  var _event$data;
  if ((event === null || event === void 0 || (_event$data = event.data) === null || _event$data === void 0 || (_event$data = _event$data.data) === null || _event$data === void 0 ? void 0 : _event$data.launchType) === SAME_WINDOW_LAUNCH_TYPE) {
    return;
  }
  forwardMessage(event);
};
export default handleRequestFullWindowLaunch;